import { deleteCategories, getCategories } from '_services';
import { ButtonHeading, CommonModal } from 'components';
import BootstrapTable from 'components/BootstrapTable';
import useDocumentTitle from 'hooks/useDocumentTitle';
import { AddCatergoryModal, EditCatergoryModal } from 'modals';
import React, { useEffect, useState } from 'react'
import toast from 'react-hot-toast';
import { AiOutlineEye } from 'react-icons/ai';
import { BsThreeDotsVertical } from 'react-icons/bs';
import { FaRegTrashCan } from 'react-icons/fa6';
import { FiEdit } from 'react-icons/fi';
import { Link } from 'react-router-dom';

const Categories = () => {
  useDocumentTitle("Categories | MySifarish");

  const [categoriesData, setCategoriesData] = useState([]);
  const [isOpen, setIsOpen] = useState(false)
  const [isEditOpen, setIsEditOpen] = useState(false)
  const [isDelete, setIsDelete] = useState()

  useEffect(() => {
    fetchCategory();
  }, []);

  // useEffect(() => {
  //     if (isDelete) {
  //       fetchCategory();
  //     }

  //   }, [isDelete]);

  const fetchCategory = async (data) => {
    try {
      const res = await getCategories();
      if (res) {
        // setTotalCount(res?.data?.totalRecords);
        setCategoriesData(res?.data?.categories);
      } else {
        toast.error(res?.responseMessage);
      }
    } catch (error) {
      toast.error(error?.message || "Something went wrong");
    }
  };

  // console.log('categoriesData **** ', categoriesData);

  const columns = [
    { header: "", accessor: "serial" },
    { header: "Category Image", accessor: "categoryImage" },
    { header: "Title ", accessor: "title" },
  ];

  const handleDelete = (item) => {
    setIsDelete(item);
  };

  const submitDeleteCategory = async () => {
    const payload = {
      categoryId: isDelete?._id,
    };
    try {
      const res = await deleteCategories(payload);
      if (!!res) {
        setIsDelete(false);
        toast.success(res?.message);
        fetchCategory();
      } else {
        toast.error("Error !! ");
      }
    } catch (error) {
      throw error;
    }
  };


  const rowListData = (data) => {
    return data?.map((item, i) => ({
      ...item,
      serial: (
        <React.Fragment>
          <div className="signDropdown">
            <button className="dropbtn11">
              <BsThreeDotsVertical />
            </button>
            <div className="dropdownContent">
              <Link
                to={`/categories/categories_details/${item?._id}`}
                state={item}
                className="_avPointer"
                style={{ textDecoration: "none" }}
              >
                <span className="_samAnchor">
                  <span className="viewIcon_avt">
                    <AiOutlineEye />
                  </span>
                  &nbsp; View
                </span>
              </Link>

              

              {item.title !== "Contents" && (
                <Link className="_avPointer" style={{ textDecoration: "none" }} onClick={() => setIsEditOpen(item)}>
                <span className="_samAnchor">
                  <span className="viewIcon_avt">
                    <FiEdit />
                  </span>
                  &nbsp; Edit
                </span>
              </Link>
              )}



              {item.title !== "Contents" && (
                <div
                  className="_avPointer"
                  onClick={() => handleDelete(item)}
                >
                  <span className="_samAnchor">
                    <span className="deleteIcon_avt">
                      <FaRegTrashCan color="red" />
                    </span>
                    Delete
                  </span>
                </div>
              )}
            </div>
          </div>
        </React.Fragment>
      ),


      title: (
        <React.Fragment>
          <div className='__anvDots' title={item?.title}>{item?.title || "-"}</div>
        </React.Fragment>
      ),


      categoryImage: (
        <React.Fragment>
          {item.imageUrl.length > 0 ? (
            <div className='__imgMedia'>
              <img
                src={item.imageUrl || "https://via.placeholder.com/400x300"}
                alt={`${item.imageUrl.length}`}
                width={40}
                height={30}
                className="_slidImg"
              />
            </div>
          ) : (
            <p>No Image Available</p>
          )}
        </React.Fragment>
      ),


    }));
  };



  const AddCategoryModal = {
    isOpen: isOpen,
    closeModal: () => setIsOpen(false),
    modalMainClass: "_dashCommon_Modal _mdModal",
    modalTitle: "Add Category",
    footerPart: true,
    submitTitle: "Add Category",
    onSuccess: fetchCategory,
  };


  const EditCategoryModal = {
    isOpen: !!isEditOpen, 
    closeModal: () => setIsEditOpen(null),
    modalMainClass: "_dashCommon_Modal _mdModal",
    modalTitle: "Edit Category",
    footerPart: true,
    submitTitle: "Edit Category",
    onSuccess: fetchCategory,
    categoryId: isEditOpen?._id,
    categoryTitle: isEditOpen?.title,
    categoryUrl: isEditOpen?.imageUrl,
  };
  
  let propsDelete = {
    isOpen: isDelete,
    closeModal: () => setIsDelete(false),
    modalMainClass: "confirmModal_new",
    footerPart: true,
    modalTitle: "Confirmation",
    submitTitle: "Confirm",
    cancelButtonTitle: "Close",
    onSubmit: submitDeleteCategory,
    // isLoadding: loading,
  };

  return (
    <>
      <ButtonHeading
        title={"Categories"}
        onClick={() => setIsOpen(!isOpen)}
        buttonTitle="Add Category"
      />

      <div className="_tabWith_outTab">
        <BootstrapTable
          columns={columns}
          data={rowListData(categoriesData?.length > 0 ? categoriesData : [])}
          tablelMainClass="__categoriesTable"
        />
      </div>

      {isOpen
        && (
          <AddCatergoryModal {...AddCategoryModal} />
        )
      }

      {isEditOpen
        && (
          <EditCatergoryModal {...EditCategoryModal} />
        )
      }

     {isDelete?._id && <CommonModal {...propsDelete}>
        <p className="p-3">
          Are you sure you want to delete this Category {isDelete?.title} ?
        </p>
      </CommonModal>
      }
    </>
  )
}

export default Categories